export default "assets/images/logo-b975ffa1.png";